import React from 'react';
import PropTypes from 'prop-types';
import UncheckedIcon from '../../../icons/UncheckedIcon';
import { Typography, withStyles } from 'material-ui';
import SelectedMealListItemStyles from './SelectedMealListItemStyles';

const UncheckedMealItem = ({ passengerId, mealId, label, className, classes }) => (
  <Typography
    key={`passenger-${passengerId}-selected-meal-${mealId}`}
    id={`passenger-${passengerId}-selected-meal-${mealId}`}
    type='title'
    color='secondary'
    variant='button'
    className={`${classes.meal} ${className}`}
  >
    <span className={classes.span}>
      {label}
      <UncheckedIcon className={classes.ml5} color='#78909c' />
    </span>
  </Typography>
);

UncheckedMealItem.propTypes = {
  mealId: PropTypes.string,
  passengerId: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(SelectedMealListItemStyles)(UncheckedMealItem);



// WEBPACK FOOTER //
// ./src/components/meals/selectedMealListItem/UncheckedMealItem.js